import { Link } from "react-router-dom";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

const Error500 = ({ error, onReload }) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-xl text-center">

        <div className="mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-red-100">
          <AlertTriangle className="h-12 w-12 text-red-600" />
        </div>

        <p className="text-sm font-semibold uppercase tracking-widest text-red-600">
          Error 500
        </p>

        <h1 className="mt-4 text-4xl font-bold tracking-tight">
          Something went wrong
        </h1>

        <p className="mt-5 text-muted-foreground">
          We're sorry, but an unexpected error occurred while loading this
          page.
        </p>

        <p className="mt-2 text-muted-foreground">
          Please refresh the page or return to the homepage.
        </p>

        {process.env.NODE_ENV === "development" && error && (
          <pre className="mt-8 rounded-lg bg-muted p-4 text-left text-xs overflow-auto">
            {error.toString()}
          </pre>
        )}

        <div className="mt-10 flex flex-wrap justify-center gap-4">

          <button
            onClick={onReload}
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-3 text-primary-foreground transition hover:opacity-90"
          >
            <RefreshCw className="h-4 w-4" />
            Reload Page
          </button>

          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg border px-5 py-3 hover:bg-muted transition"
          >
            <Home className="h-4 w-4" />
            Go Home
          </Link>

        </div>

      </div>
    </div>
  );
};

export default Error500;